import { createContext } from 'react';

const ScreenContext = createContext(null);
export default ScreenContext;